module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": 'dt-wrapper-' + _vm.dtId
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66098b1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataTable.vue
// module id = 1312
// module chunks = 2